import {
  PAYMENT_DEFAULT_SETTINGS,
  CART_DEFAULT_SETTINGS,
  DELIVERY_DEFAULT_SETTINGS,
  BENEFITS_DEFAULT_SETTINGS,
} from '@model';

import { ICartPageSettings } from '../../model';

export const CART_PAGE_DEFAULT_SETTINGS: ICartPageSettings = {
  ...CART_DEFAULT_SETTINGS,
  ...DELIVERY_DEFAULT_SETTINGS,
  ...PAYMENT_DEFAULT_SETTINGS,
  ...BENEFITS_DEFAULT_SETTINGS,
};
